/** @deprecated
  * This class represents response data serialized by ProviderNetworkCompanyBlueprint,
  * which is deprecated. For data serialized by ProviderNetworkCompanyOutput,
  * use ProviderNetworkCompany. (provider-network-company.model.ts)
  */
export class θProviderNetworkCompany {
  id: number;
  name: string;
  insurance_name: string;
  eap: boolean;
  auth_number_required: boolean;
  auth_number_visible: boolean;
  is_snap: boolean;
  network_state: string;
  logo_url: string;
  average_client_responsibility: string;
  expected_client_cost_pre_deductible: string;
  expected_client_copay_cost: string;
  minimum_contracted_rate: string;
  maximum_contracted_rate: string;
  member_number_required: boolean;
  member_number_visible: boolean;
  medicare: boolean;
  medicare_advantage: boolean;
  providers_can_add_to_clients: boolean; // TODO: PE-9096 Investigate why this is in response but not class

  constructor(providerNetwork?: { id?: number; logo_url?: string; name?: string; network_state?: string; }) {
    if (providerNetwork) {
      this.id = providerNetwork.id;
      this.logo_url = providerNetwork.logo_url;
      this.name = providerNetwork.name;
      this.network_state = providerNetwork.network_state;
    }
  }

  static fromJson(json: any): θProviderNetworkCompany {
    // eslint-disable-next-line new-cap
    return new θProviderNetworkCompany().load_from_json(json);
  }

  load_from_json(json: any): θProviderNetworkCompany {
    this.id = json.id;
    this.name = json.name;
    this.insurance_name = json.insurance_name;
    this.eap = json.eap;
    this.auth_number_visible = json.auth_number_visible;
    this.auth_number_required = json.auth_number_required;
    this.is_snap = json.is_snap; // alias for sondermind_cash_pay_network
    this.network_state = json.network_state;
    this.logo_url = json.logo;
    this.average_client_responsibility = json.average_client_responsibility;
    this.expected_client_cost_pre_deductible = json.expected_client_cost_pre_deductible;
    this.expected_client_copay_cost = json.expected_client_copay_cost;
    this.minimum_contracted_rate = json.minimum_contracted_rate;
    this.maximum_contracted_rate = json.maximum_contracted_rate;
    this.member_number_required = json.member_number_required;
    this.member_number_visible = json.member_number_required;
    this.medicare = json.medicare;
    this.medicare_advantage = json.medicare_advantage;
    return this;
  }
}

export const defaultBrandIcon = '/assets/ins-logos/generic.svg';

export function getBrandIcon(pnc: θProviderNetworkCompany, generic: string = defaultBrandIcon): string {
  const logo = pnc && pnc.logo_url;
  return logo == null || logo === '' ? generic : logo;
}
